/* eslint-disable object-curly-newline */
import APIStates from 'enum/APIStates';


const firebaseStoreInitialState = {
  authData: {
    // hls: returns from BE
    // publicHls: '', // special FE property copy of hls related to the type of the show
    // privateHls: '', // special FE property copy of hls related to the type of the show
  },
  streamingProvider: null,
  authError: '',
  isGuest: null,
  serverOffset: null,
  webUsers: {},
  roomDataReady: false,
  allowCamToCam: null,
  allowPrivateShow: null,
  allowSpyShow: false,
  broadcastId: null,
  broadcastType: null,
  fanclubImageId: null,
  mbaOrientation: null,
  mbaVersion: null,
  newShowsState: null,
  online: null,
  originUrl: null,
  privateRoom: null,
  privateShowBlocksOfTime: null,
  privateShowBlocksOfTimeActive: null,
  streamResolution: null,
  spyPricePerMinute: null,
  status: null,
  streamSource: null,
  streamUUID: null,
  tippingSessionId: null,
  uuid: null,
  viewerPricePerMinute: null,
  disconnectTimestamp: 0,
  kiirooRoom: false,
  newShowsDetails: null,
  isPrivateShowRequestActive: false,
  userKickedStatus: false,
  userBannedStatus: false,
  userPermaBannedStatus: false,
  closedRoomStatus: false,
  userNeedsId: false,
  apiToken: null,
  privateRoomLoading: APIStates.INITIAL,
  privateShowLoadingButtonState: APIStates.INITIAL,
  cancelLoadingStatePrivateShow: APIStates.INITIAL,
  userCountString: '0$0',
  boostRemainingTime: null,
  privateShowMinMinutes: 1,
  broadcastStartTime: null,
  pauseTimestamp: null,
  kcid: null,
  c2cViewerAudioMuted: false,
  c2cViewerVideoMuted: false,
  c2cPricePerMinute: null,
  blocksOfTimeIndex: 0,
  chatSettingToken: null,
  externalViewersCount: 0,
};

export default firebaseStoreInitialState;
